module.exports = __webpack_public_path__ + "img/by.5a58b05c.png";